export default {
  /**
   * ログイン情報
   */
  state() {
    return {
      /**
       * 契約情報
       */
      subscriptions: null,
      /**
       * 個人情報
       */
      info: null
    };
  },
  /**
   * ログイン情報取得
   */
  getters: {
    /**
     * 契約情報の取得
     * @param {} state
     * @returns {Object}
     */
    getUserSubscriptions(state) {
      return state.subscriptions;
    },
    /**
     * 個人情報の取得
     * @param {Object} state
     * @returns {Object}
     */
    getUserInfo(state) {
      return state.info;
    }
  },
  /**
   * ログイン情報設定
   */
  mutations: {
    /**
     * 契約情報保存
     * @param {Object} state ログイン情報
     * @param {Object} obj 設定する
     */
    setUserSubscriptions(state, obj) {
      state.subscriptions = obj;
    },
    /**
     * 個人情報保存
     * @param {Object} state 個人情報
     * @param {Object} obj 設定する値
     */
    setUserInfo(state, obj) {
      state.info = obj;
    },
    /**
     * 保存しているすべての値を削除する
     * @param {*} state
     */
    removeAll(state) {
      state.subscriptions = null;
      state.info = null;
    }
  }
};
